import { render, staticRenderFns } from "./HelpMain.vue?vue&type=template&id=3de0a886&scoped=true"
import script from "./HelpMain.vue?vue&type=script&lang=js"
export * from "./HelpMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de0a886",
  null
  
)

export default component.exports